import {
	ESubscriptionStatus,
	ESubscriptionType,
	type ISubscription,
	type TSubscription,
} from '../lib/types';

/** Reminder for mocks adjustment

	* cancellationNoticeDeadline:
		** 1st–10th: 10th of current month; 
		** after 10th: 10th of next month. 

	 * nextCancellationEffectiveDate:
		** 1st–10th: last day of current month; 
		** after 10th: last day of next month.
	
	EXAMPLES:

	1. Today: 5.04.2026 -> 
		** cancellationNoticeDeadline: '2026-04-10T23:59:59+02:00',
		** nextCancellationEffectiveDate: '2026-04-30',

	2. Today: 15.04.2026 ->
		** cancellationNoticeDeadline: '2026-05-10T23:59:59+02:00',
		** nextCancellationEffectiveDate: '2026-05-31',
*/

export const mockPausedScheduledSubscription: ISubscription = {
	id: '12a178ad-24e4-451b-9fba-6de15883e4c8',
	status: ESubscriptionStatus.ACTIVE,
	pauseStart: '2025-06-01T00:00:00Z',
	pauseEnd: '2025-06-15T10:30:00Z',
	subscriptionStart: '2025-06-01T00:00:00Z',
	type: ESubscriptionType.GERMANYTICKET,
	canceledAt: null,
	companyName: 'Vetter',
	cancellationNoticeDeadline: '2025-06-10T23:59:59+02:00',
	nextCancellationEffectiveDate: '2025-06-31',
	disallowCancelCancellation: false,
};

export const mockEndScheduledSubscription: ISubscription = {
	id: '12a178ad-24e4-451b-9fba-6de15883e4c7',
	status: ESubscriptionStatus.ACTIVE,
	type: ESubscriptionType.GERMANYTICKET,
	canceledAt: '2025-06-15T10:30:00Z',
	pauseStart: null,
	pauseEnd: null,
	subscriptionStart: '2025-06-01T00:00:00Z',
	companyName: 'Vetter',
	cancellationNoticeDeadline: '2025-06-10T23:59:59+02:00',
	nextCancellationEffectiveDate: '2025-06-31',
	disallowCancelCancellation: false,
};

export const mockActiveSubscription: ISubscription = {
	id: '12a178ad-24e4-451b-9fba-6de15883e4c7',
	status: ESubscriptionStatus.ACTIVE,
	type: ESubscriptionType.GERMANYTICKET,
	canceledAt: null,
	pauseStart: null,
	pauseEnd: null,
	subscriptionStart: '2025-06-01T00:00:00Z',
	companyName: 'Vetter',
	cancellationNoticeDeadline: '2025-06-10T23:59:59+02:00',
	nextCancellationEffectiveDate: '2025-06-31',
	disallowCancelCancellation: false,
};

export const mockPreorderedSubscription: ISubscription = {
	id: '12a178ad-24e4-451b-9fba-6de15883e4c8',
	status: ESubscriptionStatus.PREORDERED,
	pauseEnd: null,
	subscriptionStart: '2025-06-01T00:00:00Z',
	type: ESubscriptionType.GERMANYTICKET,
	canceledAt: null,
	pauseStart: null,
	companyName: 'Vetter',
	cancellationNoticeDeadline: '2025-06-10T23:59:59+02:00',
	nextCancellationEffectiveDate: '2025-06-31',
	disallowCancelCancellation: false,
};

export const mockPausedSubscription: ISubscription = {
	id: '12a178ad-24e4-451b-9fba-6de15883e4c8',
	status: ESubscriptionStatus.PAUSED,
	pauseEnd: '2025-06-15T10:30:00Z',
	subscriptionStart: '2025-06-01T00:00:00Z',
	type: ESubscriptionType.GERMANYTICKET,
	canceledAt: null,
	pauseStart: '2025-06-01T00:00:00Z',
	companyName: 'Vetter',
	cancellationNoticeDeadline: '2025-06-10T23:59:59+02:00',
	nextCancellationEffectiveDate: '2025-06-31',
	disallowCancelCancellation: false,
};

export const mockInvalidSubscription: ISubscription = {
	id: '12a178ad-24e4-451b-9fba-6de15883e4c8',
	status: ESubscriptionStatus.INVALID,
	pauseEnd: null,
	subscriptionStart: '2025-06-01T00:00:00Z',
	type: ESubscriptionType.GERMANYTICKET,
	canceledAt: null,
	pauseStart: null,
	companyName: 'Vetter',
	cancellationNoticeDeadline: '2025-06-10T23:59:59+02:00',
	nextCancellationEffectiveDate: '2025-06-31',
	disallowCancelCancellation: true,
};

export const mockNoSubscription: TSubscription = null;
